import React from 'react'
import "./Product.css"

const Product = () => {
  return (
    <div className='product'>
        <div className="product-1">
            <h1>What We Offer...</h1>
        </div>
    </div>
  )
}

export default Product